// extracted by mini-css-extract-plugin
module.exports = {"loader":"Plugs_loader__1NgVl","error":"Plugs_error__1ElrG","image":"Plugs_image__1b3HG"};